//Angular
import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

//Externos
import { NgxQRCodeModule } from "@techiediaries/ngx-qrcode";

//Componentes
import { CoursesCatalogComponent } from "./pages/main/courses-catalog/courses-catalog.component";
import { ModalCourseCardComponent } from "./components/modalCourseCard/modal-course-card.component";
import { SearchBarComponent } from "./components/searchBar/search-bar.component";
import { LoadingSpinnerModule } from "src/app/shared/spinner/loading-spinner.module";
import { SharedModule } from "../shared/shared.module";
import { MyModalCourseCardComponent } from "./components/my-modal-course-card/my-modal-course-card.component";

@NgModule({
  declarations: [
    CoursesCatalogComponent,
    SearchBarComponent,
    ModalCourseCardComponent,
    MyModalCourseCardComponent,
  ],
  exports: [
    CoursesCatalogComponent,
    SearchBarComponent,
    ModalCourseCardComponent,
  ],
  imports: [
    CommonModule,
    NgxQRCodeModule,
    FormsModule,
    LoadingSpinnerModule,
    DatePipe,
    SharedModule,
  ],
})
export class CoursesCatalogAdminModule {}
